import { OpeningOrderFeeDialog } from "./OpeningOrderFeeDialog";
import { useState } from "react";
import { Icon } from "@sellar-io/components";
import dayjs from "dayjs";
import { twMerge } from "tailwind-merge";
import { OpeningOrderFeeType } from "@sellar-io/api-v2/types";

export const OpeningOrderFeeLabel = ({
  fullLabel,
  fee,
}: {
  fullLabel?: boolean;
  fee: OpeningOrderFeeType;
}) => {
  const [active, setActive] = useState(false);

  return (
    <>
      {fullLabel ? (
        <FullLabel fee={fee} onClick={() => setActive(true)} />
      ) : (
        <SmallLabel onClick={() => setActive(true)} />
      )}
      <OpeningOrderFeeDialog
        fee={fee}
        active={active}
        onDismiss={() => setActive(false)}
      />
    </>
  );
};

const FullLabel = ({
  fee,
  onClick,
}: {
  fee: OpeningOrderFeeType;
  onClick: () => void;
}) => {
  return (
    <div
      className="flex cursor-pointer items-center rounded-lg border bg-white p-3 font-bold text-zinc-800 hover:bg-zinc-50"
      onClick={onClick}
    >
      <FeeIcon className="mr-4" />
      <span
        className={
          !!fee.waivedAt ? "font-normal text-gray-500 line-through" : ""
        }
      >
        Opening order fee {fee.legacyStripeInvoiceId ? "applied " : "applies "}
        {!fee.waivedAt ? dayjs(fee.createdAt).day(6).format("DD/MM/YY") : ""}
      </span>
      {!!fee.waivedAt && (
        <span className="ml-1 font-bold uppercase">Fee Waived</span>
      )}
      <span className="ml-auto flex items-center">
        See details
        <Icon icon="CHEVRON_RIGHT" size={1} className="ml-1" />
      </span>
    </div>
  );
};

const SmallLabel = ({ onClick }: { onClick: () => void }) => {
  return <FeeIcon onClick={onClick} className="ml-2" />;
};

const FeeIcon = ({
  onClick,
  className,
}: {
  onClick?: () => void;
  className?: string;
}) => {
  return (
    <div
      onClick={onClick}
      className={twMerge(
        "flex h-6 w-6 cursor-pointer items-center justify-center rounded-sm bg-[#E8CCFC] text-[#B557F1]",
        className,
      )}
    >
      <Icon icon="ACCOUNT_TAG_OUTLINE" size={0.75} />
    </div>
  );
};
